<template>
  <div>
    <div class="d-flex">
      <v-text-field
        v-model="name"
        required
        outlined
        dense
        counter="40"
        maxLength="40"
        :label="`${$t('boards.column_name')}*`"
        :rules="[
          () =>
            isNameValid || this.$t('validation.form.this_field_is_required'),
        ]"
        @change="emitChange"
      />
      <v-select
        v-model="sort"
        outlined
        dense
        hide-details
        prepend-inner-icon="mdi-sort"
        class="ml-4 sort-form-selector "
        :label="$t('common.sort.sort')"
        :items="sortOptions"
        :value="`${column.sort.by}-${column.sort.order}`"
        @change="emitChange"
      />
    </div>
    <template>
      <p class="pb-1 ma-0 subtitle-2 blue-grey--text text--darken-1">
        {{ $t('boards.select_my_filters') }}
      </p>
      <div class="d-flex align-center flex-wrap">
        <UserFilters
          :isEditable="false"
          @onSelectFilter="handleSelectUserFilter($event)"
        />
        <UserFiltersChips
          :initialFilters="userFilters"
          :showPinnedFilters="false"
          @onRemoveActiveFilter="resetFilters"
        />
      </div>
    </template>
    <Filters
      hideApplyButton
      hideSaveButton
      class="mt-5"
      :initialFilters="filter"
      @change="handleFiltersChange"
    />
    <v-text-field
      v-model="filter"
      required
      class="field-to-validate-filters-in-column mt-0 pt-0 ml-3"
      :rules="[() => isFiltersValid || this.$t('boards.error_empty_filters')]"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import Filters from '@/components/Filters/Filters.vue'
import UserFilters from '@/containers/Explore/Filters/UserFilters.vue'
import UserFiltersChips from '@/containers/Explore/Filters/UserFiltersChips.vue'

export default {
  name: 'ColumnForm',

  props: {
    column: {
      type: Object,
      default: () => {},
    },
  },

  components: { Filters, UserFilters, UserFiltersChips },

  data() {
    return {
      name: '',
      sort: 'createdAt-desc',
      filter: {},
      userFilters: {
        filters: this.column?.userFilter?.filters,
        id: this.column?.userFilter?.id ?? null,
        name: this.column?.userFilter?.name ?? null,
      },
    }
  },

  watch: {
    column: {
      immediate: true,
      handler() {
        this.name = this.column.name
        this.filter = this.column?.userFilter?.id
          ? _.omitBy(
              this.column?.userFilter?.filters,
              (value, key) =>
                (_.isArray(value) && _.isEmpty(value)) ||
                _.isNull(value) ||
                key == '_id'
            )
          : this.column.filter
        this.sort = `${this.column.sort.by}-${this.column.sort.order}`
        this.userFilters = {
          filters: this.column?.userFilter?.filters,
          id: this.column?.userFilter?.id,
          name: this.column?.userFilter?.name,
        }
      },
    },
  },

  computed: {
    sortOptions() {
      return [
        {
          text: this.$t('common.sort.last_updated'),
          value: 'updatedAt-desc',
        },
        {
          text: this.$t('common.alphabetically'),
          value: 'name-asc',
        },
        {
          text: this.$t('common.highest_priority'),
          value: 'priorityScore-desc',
        },
        {
          text: this.$t('boards.sort.due_date'),
          value: 'dueDate-asc',
        },
        {
          text: this.$t('common.sort.last_created'),
          value: 'createdAt-desc',
        },
      ]
    },

    isNameValid() {
      return !!this.name.trim()
    },

    isFiltersValid() {
      return (
        Object.keys(this.filter).filter(filterKey =>
          _.isArray(this.filter[filterKey])
            ? this.filter[filterKey].length
            : this.filter[filterKey]
        ).length > 0
      )
    },
  },

  methods: {
    handleFiltersChange({ serializedFilters }) {
      this.userFilters = {}
      this.filter = serializedFilters
      this.emitChange()
    },

    emitChange() {
      const [by, order] = this.sort.split('-')
      this.$emit('change', {
        name: this.name,
        sort: { order, by },
        filter: this.userFilters?.id ? {} : this.filter,
        userFilter: this.userFilters,
      })
    },
    handleSelectUserFilter(newFilter) {
      this.filter = _.omitBy(
        newFilter,
        (value, key) =>
          key === 'userFilter' ||
          key === 'userFilterName' ||
          (_.isArray(value) && _.isEmpty(value)) ||
          _.isNull(value)
      )
      this.userFilters = {
        filters: this.filter,
        id: newFilter?.userFilter,
        name: newFilter?.userFilterName,
      }
      this.emitChange()
    },

    resetFilters() {
      this.userFilters = {}
      this.filter = {}
    },
  },
}
</script>

<style lang="scss" scoped>
.sort-form-selector {
  max-width: 200px;
}
</style>

<style>
.v-input.field-to-validate-filters-in-column .v-input__control .v-input__slot {
  display: none !important;
}
</style>
